import React from 'react'
import { Center, VStack, Spinner, Text } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { useAppTranslation } from '@/contexts/LanguageContext'

const MotionBox = motion.div

interface LoadingStateProps {
  message?: string
}

export default function LoadingState({ message }: LoadingStateProps) {
  const { t } = useAppTranslation('files')
  return (
    <MotionBox
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
    >
      <Center h="400px">
        <VStack spacing={4}>
          <Spinner size="xl" color="blue.500" thickness="4px" />
          <Text color="gray.600" fontSize="lg" fontWeight="medium">
            {message || t('fileExplorer.loadingFiles')}
          </Text>
        </VStack>
      </Center>
    </MotionBox>
  )
}
